import { tokenResponseGuard } from '@logto/connector-kit';
import { z } from 'zod';
import { SecretEnterpriseSsoConnectorRelations } from '../db-entries/secret-enterprise-sso-connector-relation.js';
import { SecretSocialConnectorRelations } from '../db-entries/secret-social-connector-relation.js';
import { Secrets } from '../db-entries/secret.js';
import { SecretType } from '../foundations/index.js';
export const encryptedSecretGuard = Secrets.guard.pick({
    encryptedDek: true,
    iv: true,
    authTag: true,
    ciphertext: true,
});
export const tokenSetGuard = z.object({
    id_token: z.string().optional(),
    access_token: z.string(),
    refresh_token: z.string().optional(),
});
export const tokenSetMetadataGuard = z.object({
    scope: z.string().optional(),
    expiresAt: z.number().optional(),
    tokenType: z.string().optional(),
    hasRefreshToken: z.boolean(),
});
export const encryptedTokenSetGuard = z.object({
    encryptedTokenSetBase64: z.string(),
    metadata: tokenSetMetadataGuard,
});
export const secretSocialConnectorRelationPayloadGuard = SecretSocialConnectorRelations.createGuard.pick({
    connectorId: true,
    target: true,
    identityId: true,
});
export const secretEnterpriseSsoConnectorRelationPayloadGuard = SecretEnterpriseSsoConnectorRelations.createGuard.pick({
    ssoConnectorId: true,
    issuer: true,
    identityId: true,
});
export const socialTokenSetSecretGuard = Secrets.guard.extend({
    type: z.literal(SecretType.FederatedTokenSet),
    metadata: tokenSetMetadataGuard,
    connectorId: z.string(),
    identityId: z.string(),
    target: z.string(),
});
export const desensitizedSocialTokenSetSecretGuard = socialTokenSetSecretGuard.omit({
    encryptedDek: true,
    iv: true,
    authTag: true,
    ciphertext: true,
});
export const enterpriseSsoTokenSetSecretGuard = Secrets.guard.extend({
    type: z.literal(SecretType.FederatedTokenSet),
    metadata: tokenSetMetadataGuard,
    ssoConnectorId: z.string(),
    issuer: z.string(),
    identityId: z.string(),
});
export const desensitizedEnterpriseSsoTokenSetSecretGuard = enterpriseSsoTokenSetSecretGuard.omit({
    encryptedDek: true,
    iv: true,
    authTag: true,
    ciphertext: true,
});
export const getThirdPartyAccessTokenResponseGuard = tokenResponseGuard
    .pick({
    access_token: true,
    scope: true,
    token_type: true,
    expires_in: true,
})
    .extend({
    access_token: z.string(),
});
